import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66cad620"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card py-3 mb-10" }
const _hoisted_2 = { class: "container p-4" }
const _hoisted_3 = { class: "nav-back mb-4" }
const _hoisted_4 = { class: "d-flex justify-content-between col-12" }
const _hoisted_5 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_6 = { class: "form-check form-switch d-flex justify-content-center align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ms-3",
  for: "flexSwitchCheckMinPurchase"
}, " Promotion Status ", -1))
const _hoisted_8 = { class: "input-box" }
const _hoisted_9 = { class: "d-flex flex-wrap justify-content-between align-items-center" }
const _hoisted_10 = { class: "col-sm-6 col-xs-12" }
const _hoisted_11 = { class: "col-sm-6 ps-4 col-xs-12" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("New User")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("All User")
const _hoisted_14 = { class: "d-flex flex-wrap justify-content-start align-items-start" }
const _hoisted_15 = { class: "d-flex flex-column col-sm-6 col-xs-12 me-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "font-weight-bold mb-4",
  for: "description"
}, " Description ", -1))
const _hoisted_17 = { class: "input-group mb-3" }
const _hoisted_18 = { class: "input-box" }
const _hoisted_19 = { class: "d-flex flex-wrap justify-content-between align-items-start" }
const _hoisted_20 = {
  key: 0,
  class: "col-12 box-mb"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Discount/Bath ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Discount/Percent ")
const _hoisted_23 = {
  key: 1,
  class: "col-12 box-mb"
}
const _hoisted_24 = { class: "d-flex flex-wrap justify-content-start align-items-start" }
const _hoisted_25 = { class: "d-flex flex-column col-md-4 col-sm-12 pe-4" }
const _hoisted_26 = {
  class: "font-weight-bold mb-4",
  for: "discountAmount"
}
const _hoisted_27 = { class: "d-flex flex-column col-md-4 col-sm-12 pe-4" }
const _hoisted_28 = { class: "form-check form-switch mb-4" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckMinPurchase"
}, " Minimum Purchase ", -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("THB")
const _hoisted_32 = {
  key: 0,
  class: "d-flex flex-column col-md-4 col-sm-12"
}
const _hoisted_33 = { class: "form-check form-switch mb-4" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckMaxDiscount"
}, " Maximum Discount ", -1))
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("THB")
const _hoisted_37 = { class: "input-box" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "promotionTarget",
  class: "form-label pe-4 title mb-4"
}, " Promotion Time ", -1))
const _hoisted_39 = { class: "d-flex flex-wrap justify-content-start align-items-center" }
const _hoisted_40 = { class: "d-flex flex-wrap justify-content-start align-items-start" }
const _hoisted_41 = { class: "me-2 d-flex flex-column" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Start", -1))
const _hoisted_43 = { class: "me-2 d-flex flex-column" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Time", -1))
const _hoisted_45 = { class: "d-flex flex-wrap justify-content-start align-items-start" }
const _hoisted_46 = { class: "me-2 d-flex flex-column" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " ", -1))
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_49 = { class: "d-flex flex-wrap justify-content-start align-items-start" }
const _hoisted_50 = { class: "me-2 d-flex flex-column" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "End", -1))
const _hoisted_52 = { class: "me-2 d-flex flex-column" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Time", -1))
const _hoisted_54 = { class: "input-box" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label pe-4 title box-mb" }, " Promotion Setting ", -1))
const _hoisted_56 = { class: "d-flex flex-wrap justify-content-between align-items-start" }
const _hoisted_57 = { class: "col-12 box-mb" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Fix ")
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Prefix ")
const _hoisted_60 = { class: "d-flex flex-wrap justify-content-start align-items-start box-mb" }
const _hoisted_61 = { class: "d-flex flex-column col-w33 me-4" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "font-weight-bold mb-4",
  for: "code"
}, "Code", -1))
const _hoisted_63 = { class: "d-flex flex-column col-w33" }
const _hoisted_64 = {
  class: "font-weight-bold mb-4",
  for: "amountForAll"
}
const _hoisted_65 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { key: 2 }
const _hoisted_69 = { class: "d-flex flex-wrap justify-content-start align-items-start" }
const _hoisted_70 = { class: "d-flex flex-column col-w33 me-4" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "font-weight-bold mb-4",
  for: "amountPerUser"
}, " Amount use per user ", -1))
const _hoisted_72 = { class: "input-box" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label pe-4 title box-mb" }, " Condition Setting ", -1))
const _hoisted_74 = { class: "d-flex pb-3 mb-3" }
const _hoisted_75 = { class: "form-check" }
const _hoisted_76 = ["checked"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isPaymentType"
}, " Payment Type ", -1))
const _hoisted_78 = {
  key: 0,
  class: "ps-4 pb-4 mb-4"
}
const _hoisted_79 = ["id", "name", "onUpdate:modelValue", "checked"]
const _hoisted_80 = ["for"]
const _hoisted_81 = { class: "d-flex pb-3 mb-3" }
const _hoisted_82 = { class: "form-check" }
const _hoisted_83 = ["checked"]
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isCarPackage"
}, " Service Type ", -1))
const _hoisted_85 = {
  key: 1,
  class: "ps-4 pb-4 mb-4"
}
const _hoisted_86 = ["id", "name", "onUpdate:modelValue", "checked"]
const _hoisted_87 = ["for"]
const _hoisted_88 = { class: "d-flex pb-3 mb-3" }
const _hoisted_89 = { class: "form-check" }
const _hoisted_90 = ["checked"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isStore"
}, " Store ", -1))
const _hoisted_92 = {
  key: 2,
  class: "ps-4 pb-4 mb-4"
}
const _hoisted_93 = { class: "d-flex pb-3 mb-3" }
const _hoisted_94 = { class: "form-check" }
const _hoisted_95 = ["checked"]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isPackage"
}, " Packages ", -1))
const _hoisted_97 = {
  key: 3,
  class: "ps-4 pb-4 mb-4"
}
const _hoisted_98 = { class: "d-flex pb-3 mb-3" }
const _hoisted_99 = { class: "form-check" }
const _hoisted_100 = ["checked"]
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isServicePoint"
}, " Node ", -1))
const _hoisted_102 = {
  key: 4,
  class: "ps-4 pb-4 mb-4"
}
const _hoisted_103 = { class: "d-flex pb-3 mb-3" }
const _hoisted_104 = { class: "form-check" }
const _hoisted_105 = ["checked"]
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isCustomCar"
}, " Custom Car ", -1))
const _hoisted_107 = {
  key: 5,
  class: "ps-4 pb-4 mb-4"
}
const _hoisted_108 = { class: "d-flex pb-3 mb-3" }
const _hoisted_109 = { class: "form-checks" }
const _hoisted_110 = ["checked"]
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isSeries"
}, "Car Types", -1))
const _hoisted_112 = {
  key: 0,
  class: "ps-4 pb-4 mb-4"
}
const _hoisted_113 = { class: "d-flex pb-3 mb-3" }
const _hoisted_114 = { class: "form-checks" }
const _hoisted_115 = ["checked"]
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isBrands"
}, "Brands", -1))
const _hoisted_117 = {
  key: 1,
  class: "ps-4 pb-4 mb-4"
}
const _hoisted_118 = { class: "d-flex pb-3 mb-3" }
const _hoisted_119 = { class: "form-checks" }
const _hoisted_120 = ["checked"]
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isModels"
}, "Car Models", -1))
const _hoisted_122 = {
  key: 2,
  class: "ps-4 pb-4 mb-4"
}
const _hoisted_123 = { class: "d-flex pb-3 mb-3" }
const _hoisted_124 = { class: "form-check" }
const _hoisted_125 = ["checked"]
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isPeriod"
}, "Period", -1))
const _hoisted_127 = {
  key: 6,
  class: "ps-4 pb-4 mb-4"
}
const _hoisted_128 = { class: "d-flex justify-contents-end align-items-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPallette = _resolveComponent("IconPallette")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_AddStoreCondition = _resolveComponent("AddStoreCondition")!
  const _component_StoreConditionList = _resolveComponent("StoreConditionList")!
  const _component_AddPackageCondition = _resolveComponent("AddPackageCondition")!
  const _component_PackageConditionList = _resolveComponent("PackageConditionList")!
  const _component_AddServicePointCondition = _resolveComponent("AddServicePointCondition")!
  const _component_ServicePointConditionList = _resolveComponent("ServicePointConditionList")!
  const _component_AddCarSeriesCondition = _resolveComponent("AddCarSeriesCondition")!
  const _component_SeriesConditionList = _resolveComponent("SeriesConditionList")!
  const _component_AddCarBrandCondition = _resolveComponent("AddCarBrandCondition")!
  const _component_BrandConditionList = _resolveComponent("BrandConditionList")!
  const _component_AddCarModelCondition = _resolveComponent("AddCarModelCondition")!
  const _component_CarModelConditionList = _resolveComponent("CarModelConditionList")!
  const _component_AddPeriodCondition = _resolveComponent("AddPeriodCondition")!
  const _component_PeriodConditionList = _resolveComponent("PeriodConditionList")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    false
      ? (_openBlock(), _createBlock(_component_IconPallette, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/promotions" }, {
              default: _withCtx(() => [
                _createVNode(_component_inline_svg, { src: `media/icons/duotune/arrows/arr063.svg` }, null, 8, ["src"]),
                _createElementVNode("label", null, _toDisplayString(_ctx.promotionId ? 'Update Promotion' : 'Create Promotion'), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "flexSwitchCheckMinPurchase",
              name: "isActive",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.isActive) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleChangeStatus && $setup.handleChangeStatus(...args)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.formData.isActive]
            ]),
            _hoisted_7,
            _createElementVNode("span", {
              class: _normalizeClass(["ms-2 fw-bold", {
                ['text-danger']: !_ctx.formData.isActive,
                ['text-success']: _ctx.formData.isActive,
              }])
            }, _toDisplayString(_ctx.formData.isActive ? 'On' : 'Off'), 3)
          ])
        ])
      ]),
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.formData,
        rules: $setup.elRules,
        class: "row g-3 needs-validation"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_form_item, {
                  prop: "name",
                  label: "Name: "
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      id: "promotionName",
                      type: "text",
                      name: "name",
                      placeholder: "Promotion Name",
                      modelValue: _ctx.formData.name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.name) = $event)),
                      required: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_form_item, {
                  prop: "isNewUser",
                  label: "Promotion Target: "
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.formData.isNewUser,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.isNewUser) = $event)),
                      class: "ml-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, {
                          label: true,
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, {
                          label: false,
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("textarea", {
                    style: {"resize":"none"},
                    id: "description",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.description) = $event)),
                    rows: "5",
                    draggable: "false"
                  }, null, 512), [
                    [_vModelText, _ctx.formData.description]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              (!_ctx.promotionId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createVNode(_component_el_form_item, {
                      prop: "amountType",
                      label: "Discount Type"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: _ctx.formData.amountType,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.amountType) = $event)),
                          class: "ml-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, {
                              label: $setup.AmountTypeEnum.FIXED,
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_21
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_radio, {
                              label: $setup.AmountTypeEnum.PERCENTAGE,
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_22
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_23, " Discount Type: " + _toDisplayString(_ctx.formData.amountType == $setup.AmountTypeEnum.FIXED
                  ? 'Discount/Bath'
                  : 'Discount/Percent'), 1))
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formData.amountType == $setup.AmountTypeEnum.PERCENTAGE
                      ? 'Discount Percent'
                      : 'Discount Bath'), 1)
                ]),
                _createVNode(_component_el_form_item, { prop: "amount" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      id: "discountAmount",
                      name: "discountAmount",
                      placeholder: 
                    _ctx.formData.amountType == $setup.AmountTypeEnum.PERCENTAGE
                      ? 'Discount Percent'
                      : 'Discount Bath'
                  ,
                      modelValue: _ctx.formData.amount,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.amount) = $event)),
                      modelModifiers: { number: true },
                      disabled: _ctx.formData.amountType == null || !!_ctx.promotionId,
                      required: ""
                    }, {
                      append: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formData.amountType == $setup.AmountTypeEnum.PERCENTAGE
                        ? '%'
                        : 'THB'), 1)
                      ]),
                      _: 1
                    }, 8, ["placeholder", "modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    id: "flexSwitchCheckMinPurchase",
                    name: "isMinPurchase",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.isMinPurchase) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.formData.isMinPurchase]
                  ]),
                  _hoisted_29,
                  _createElementVNode("span", {
                    class: _normalizeClass(["ms-2 fw-bold", {
                    ['text-danger']: !_ctx.formData.isMinPurchase,
                    ['text-success']: _ctx.formData.isMinPurchase,
                  }])
                  }, _toDisplayString(_ctx.formData.isMinPurchase ? 'On' : 'Off'), 3)
                ]),
                (_ctx.formData.isMinPurchase)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createVNode(_component_el_form_item, { prop: "minPurchase" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            id: "minPurchase",
                            name: "minPurchase",
                            placeholder: "Min Purchase",
                            modelValue: _ctx.formData.minPurchase,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.minPurchase) = $event)),
                            modelModifiers: { number: true },
                            required: _ctx.formData.isMinPurchase
                          }, {
                            append: _withCtx(() => [
                              _hoisted_31
                            ]),
                            _: 1
                          }, 8, ["modelValue", "required"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.formData.amountType == $setup.AmountTypeEnum.PERCENTAGE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "flexSwitchCheckMaxDiscount",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.isMaxDiscount) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.formData.isMaxDiscount]
                      ]),
                      _hoisted_34,
                      _createElementVNode("span", {
                        class: _normalizeClass(["ms-2 fw-bold", {
                    ['text-danger']: !_ctx.formData.isMaxDiscount,
                    ['text-success']: _ctx.formData.isMaxDiscount,
                  }])
                      }, _toDisplayString(_ctx.formData.isMaxDiscount ? 'On' : 'Off'), 3)
                    ]),
                    (_ctx.formData.isMaxDiscount)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createVNode(_component_el_form_item, { prop: "maxDiscount" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                type: "text",
                                id: "maxDiscount",
                                name: "maxDiscount",
                                placeholder: "Max Discount",
                                modelValue: _ctx.formData.maxDiscount,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.maxDiscount) = $event)),
                                modelModifiers: { number: true },
                                required: _ctx.formData.isMaxDiscount
                              }, {
                                append: _withCtx(() => [
                                  _hoisted_36
                                ]),
                                _: 1
                              }, 8, ["modelValue", "required"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createVNode(_component_el_form_item, { prop: "startDatePath" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        type: "date",
                        modelValue: _ctx.formData.startDatePath,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.startDatePath) = $event)),
                        class: "w-150px",
                        placeholder: "DD/MM/YY"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createVNode(_component_el_form_item, { prop: "startTimePath" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_time_picker, {
                        type: "time",
                        modelValue: _ctx.formData.startTimePath,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.startTimePath) = $event)),
                        class: "w-150px",
                        placeholder: "00:00"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createVNode(_component_el_form_item, { prop: "forSame" }, {
                    default: _withCtx(() => [
                      _hoisted_48
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createVNode(_component_el_form_item, { prop: "endDatePath" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        type: "date",
                        modelValue: _ctx.formData.endDatePath,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.endDatePath) = $event)),
                        class: "w-150px danger",
                        placeholder: "DD/MM/YY",
                        "disabled-date": 
                      (date) => date.getTime() < _ctx.formData.startDate
                    
                      }, null, 8, ["modelValue", "disabled-date"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createVNode(_component_el_form_item, { prop: "endTimePath" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_time_picker, {
                        type: "time",
                        modelValue: _ctx.formData.endTimePath,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.endTimePath) = $event)),
                        class: "w-150px",
                        placeholder: "00:00",
                        start: "01:00"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_component_el_form_item, {
                  prop: "type",
                  label: "Fix Type: "
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.formData.type,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.type) = $event)),
                      class: "ml-4",
                      disabled: !!_ctx.promotionId
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, {
                          label: $setup.PromotionTypeEnum.FIX,
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_58
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_radio, {
                          label: $setup.PromotionTypeEnum.PREFIX,
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_59
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                _createVNode(_component_el_form_item, { prop: "code" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      id: "code",
                      type: "text",
                      name: "code",
                      placeholder: "Promotion Code",
                      modelValue: _ctx.formData.code,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.code) = $event)),
                      disabled: !!_ctx.promotionId,
                      required: ""
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("label", _hoisted_64, [
                  _createTextVNode(_toDisplayString(_ctx.promotionId ? 'Add ' : '') + " " + _toDisplayString(_ctx.formData.type == $setup.PromotionTypeEnum.PREFIX
                    ? 'Prefix Amount'
                    : 'Amount use for all') + " ", 1),
                  (
                    _ctx.promotionId && _ctx.formData.type == $setup.PromotionTypeEnum.PREFIX
                  )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_65, " Current: " + _toDisplayString($setup.numberFormat(_ctx.couponTotal)), 1))
                    : _createCommentVNode("", true)
                ]),
                (
                  !_ctx.promotionId ||
                  (_ctx.promotionId && _ctx.formData.type == $setup.PromotionTypeEnum.FIX)
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                      _createVNode(_component_el_form_item, { prop: "quantity" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            id: "quantity",
                            type: "text",
                            name: "quantity",
                            placeholder: 
                      _ctx.formData.type == $setup.PromotionTypeEnum.PREFIX
                        ? 'Prefix Amount'
                        : 'Amount use for all'
                    ,
                            modelValue: _ctx.formData.quantity,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.quantity) = $event)),
                            modelModifiers: { number: true },
                            required: ""
                          }, null, 8, ["placeholder", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]))
                  : (_ctx.isAddCoupon)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        _createVNode(_component_el_form_item, { prop: "quantity" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              id: "quantity",
                              type: "text",
                              name: "quantity",
                              placeholder: 
                      _ctx.formData.type == $setup.PromotionTypeEnum.PREFIX
                        ? 'Prefix Amount'
                        : 'Amount use for all'
                    ,
                              modelValue: _ctx.formData.quantity,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.quantity) = $event)),
                              modelModifiers: { number: true },
                              required: ""
                            }, null, 8, ["placeholder", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[19] || (_cache[19] = () => (_ctx.isAddCoupon = !_ctx.isAddCoupon)),
                          class: "btn btn-primary"
                        }, " + Add Coupon ")
                      ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("div", null, [
                  _createVNode(_component_el_form_item, { prop: "limitPerUser" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        id: "limitPerUser",
                        type: "text",
                        name: "limitPerUser",
                        placeholder: "Amount use per user",
                        modelValue: _ctx.formData.limitPerUser,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.limitPerUser) = $event)),
                        modelModifiers: { number: true },
                        required: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_72, [
            _hoisted_73,
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.isPaymentType) = $event)),
                  class: "form-check-input",
                  name: "isPaymentType",
                  type: "checkbox",
                  id: "isPaymentType",
                  checked: _ctx.formData.isPaymentType
                }, null, 8, _hoisted_76), [
                  [_vModelCheckbox, _ctx.formData.isPaymentType]
                ]),
                _hoisted_77
              ])
            ]),
            (_ctx.formData.isPaymentType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.PaymentTypes, (paymentType) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "form-check mb-4 pb-2",
                      key: paymentType
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        id: `paymentTypes${paymentType}`,
                        name: `paymentTypes${paymentType}`,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.formData.paymentTypesOption[paymentType]) = $event),
                        class: "form-check-input",
                        type: "checkbox",
                        checked: _ctx.formData.paymentTypesOption[paymentType]
                      }, null, 8, _hoisted_79), [
                        [_vModelCheckbox, _ctx.formData.paymentTypesOption[paymentType]]
                      ]),
                      _createElementVNode("label", {
                        class: "form-check-label",
                        for: `paymentTypes${paymentType}`
                      }, _toDisplayString(paymentType), 9, _hoisted_80)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.isCarPackage) = $event)),
                  class: "form-check-input",
                  name: "isCarPackage",
                  type: "checkbox",
                  id: "isCarPackage",
                  checked: _ctx.formData.isCarPackage
                }, null, 8, _hoisted_83), [
                  [_vModelCheckbox, _ctx.formData.isCarPackage]
                ]),
                _hoisted_84
              ])
            ]),
            (_ctx.formData.isCarPackage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.ServicesTypes, (serviceType) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "form-check mb-4 pb-2",
                      key: serviceType.value
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        id: `serviceType${serviceType.value}`,
                        name: `serviceType${serviceType.value}`,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.formData.carPackagesOption[serviceType.value]) = $event),
                        class: "form-check-input",
                        type: "checkbox",
                        checked: _ctx.formData.carPackagesOption[serviceType.value]
                      }, null, 8, _hoisted_86), [
                        [_vModelCheckbox, _ctx.formData.carPackagesOption[serviceType.value]]
                      ]),
                      _createElementVNode("label", {
                        class: "form-check-label",
                        for: `serviceType${serviceType.value}`
                      }, _toDisplayString(serviceType.name), 9, _hoisted_87)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.isStore) = $event)),
                  class: "form-check-input",
                  name: "isStore",
                  type: "checkbox",
                  id: "isStore",
                  checked: _ctx.formData.isStore
                }, null, 8, _hoisted_90), [
                  [_vModelCheckbox, _ctx.formData.isStore]
                ]),
                _hoisted_91
              ]),
              (_ctx.formData.isStore)
                ? (_openBlock(), _createBlock(_component_AddStoreCondition, {
                    key: 0,
                    modelValue: _ctx.formData.stores,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.stores) = $event))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.formData.isStore)
              ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                  _createVNode(_component_StoreConditionList, {
                    modelValue: _ctx.formData.stores,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.stores) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.isPackage) = $event)),
                  class: "form-check-input",
                  name: "isPackage",
                  type: "checkbox",
                  id: "isPackage",
                  checked: _ctx.formData.isPackage
                }, null, 8, _hoisted_95), [
                  [_vModelCheckbox, _ctx.formData.isPackage]
                ]),
                _hoisted_96
              ]),
              (_ctx.formData.isPackage)
                ? (_openBlock(), _createBlock(_component_AddPackageCondition, {
                    key: 0,
                    modelValue: _ctx.formData.packages,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.packages) = $event))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.formData.isPackage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                  _createVNode(_component_PackageConditionList, {
                    modelValue: _ctx.formData.packages,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.packages) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.isServicePoint) = $event)),
                  class: "form-check-input",
                  name: "isServicePoint",
                  type: "checkbox",
                  id: "isServicePoint",
                  checked: _ctx.formData.isServicePoint
                }, null, 8, _hoisted_100), [
                  [_vModelCheckbox, _ctx.formData.isServicePoint]
                ]),
                _hoisted_101
              ]),
              (_ctx.formData.isServicePoint)
                ? (_openBlock(), _createBlock(_component_AddServicePointCondition, {
                    key: 0,
                    modelValue: _ctx.formData.servicePoints,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData.servicePoints) = $event))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.formData.isServicePoint)
              ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                  _createVNode(_component_ServicePointConditionList, {
                    modelValue: _ctx.formData.servicePoints,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData.servicePoints) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("div", _hoisted_104, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData.isCustomCar) = $event)),
                  class: "form-check-input",
                  name: "isCustomCar",
                  type: "checkbox",
                  id: "isCustomCar",
                  checked: _ctx.formData.isCustomCar
                }, null, 8, _hoisted_105), [
                  [_vModelCheckbox, _ctx.formData.isCustomCar]
                ]),
                _hoisted_106
              ])
            ]),
            (_ctx.formData.isCustomCar)
              ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                  _createElementVNode("div", _hoisted_108, [
                    _createElementVNode("div", _hoisted_109, [
                      false
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.isSeries) = $event)),
                            class: "form-check-input",
                            name: "isSeries",
                            type: "checkbox",
                            id: "isSeries",
                            checked: _ctx.formData.isSeries
                          }, null, 8, _hoisted_110)), [
                            [_vModelCheckbox, _ctx.formData.isSeries]
                          ])
                        : _createCommentVNode("", true),
                      _hoisted_111
                    ]),
                    (_ctx.formData.isSeries)
                      ? (_openBlock(), _createBlock(_component_AddCarSeriesCondition, {
                          key: 0,
                          modelValue: _ctx.formData.series,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData.series) = $event))
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.formData.isSeries)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                        _createVNode(_component_SeriesConditionList, {
                          modelValue: _ctx.formData.series,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData.series) = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("div", _hoisted_114, [
                      false
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formData.isBrands) = $event)),
                            class: "form-check-input",
                            name: "isBrands",
                            type: "checkbox",
                            id: "isBrands",
                            checked: _ctx.formData.isBrands
                          }, null, 8, _hoisted_115)), [
                            [_vModelCheckbox, _ctx.formData.isBrands]
                          ])
                        : _createCommentVNode("", true),
                      _hoisted_116
                    ]),
                    (_ctx.formData.isBrands)
                      ? (_openBlock(), _createBlock(_component_AddCarBrandCondition, {
                          key: 0,
                          modelValue: _ctx.formData.brands,
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.formData.brands) = $event))
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.formData.isBrands)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                        _createVNode(_component_BrandConditionList, {
                          modelValue: _ctx.formData.brands,
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formData.brands) = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("div", _hoisted_119, [
                      false
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.formData.isModels) = $event)),
                            class: "form-check-input",
                            name: "isModels",
                            type: "checkbox",
                            id: "isModels",
                            checked: _ctx.formData.isModels
                          }, null, 8, _hoisted_120)), [
                            [_vModelCheckbox, _ctx.formData.isModels]
                          ])
                        : _createCommentVNode("", true),
                      _hoisted_121
                    ]),
                    (_ctx.formData.isModels)
                      ? (_openBlock(), _createBlock(_component_AddCarModelCondition, {
                          key: 0,
                          modelValue: _ctx.formData.models,
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.formData.models) = $event))
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.formData.isModels)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                        _createVNode(_component_CarModelConditionList, {
                          modelValue: _ctx.formData.models,
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.formData.models) = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_123, [
              _createElementVNode("div", _hoisted_124, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.formData.isPeriod) = $event)),
                  class: "form-check-input",
                  name: "isPeriod",
                  type: "checkbox",
                  id: "isPeriod",
                  checked: _ctx.formData.isPeriod
                }, null, 8, _hoisted_125), [
                  [_vModelCheckbox, _ctx.formData.isPeriod]
                ]),
                _hoisted_126
              ]),
              (_ctx.formData.isPeriod)
                ? (_openBlock(), _createBlock(_component_AddPeriodCondition, {
                    key: 0,
                    modelValue: _ctx.formData.periods,
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.formData.periods) = $event))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.formData.isPeriod)
              ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                  _createVNode(_component_PeriodConditionList, {
                    modelValue: _ctx.formData.periods,
                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.formData.periods) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_128, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[45] || (_cache[45] = ($event: any) => ($setup.handleSubmit($setup.formRef))),
              class: "btn btn-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.promotionId ? 'Update Promotion' : 'Create Promotion'), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}